// extracted by mini-css-extract-plugin
export default {"container":"Feature_container__BI2li","circle":"Feature_circle__GjUIn","description":"Feature_description__Mj6UF","faIcon":"Feature_faIcon__axXlM","header":"Feature_header__zE+wq"};